
import {HttpHolidayList,HttpDeleteHolidayOne} from '@/service/holiday';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';

export default {
    mixins: [TableList],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                isManage: false,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpHolidayList,
       
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('fbb.holiday.add', { defaultValue: "添加节假日管理"}),
                        show:true,
                        width:600,
                        activeid:params,
                        component: "comIndex",
                        type:'add',
                        showFooter:false,
                    }
                    break;   
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:600,
                        component: "comIndex",
                        activeid:params,
                        type:'query',
                        showFooter:false,
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:600,
                        component: "comIndex",
                        activeid:params,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteHolidayOne,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                params: id,
                operate: 'delete',
                show: true
            },
          ]
        },
    },
    computed: {
        ...mapGetters('dictionary', []),
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: '添加' }),
                operate: "add",
                theme: "primary",
            }]
        },
        SearchsData() {
            return [
                  
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: 'countryCode',
                    width: 100,
                },{
                    title: this.$t('fbb.holiday.description', { defaultValue: '节假日描述' }),
                    key: 'description',
                }, 
                {
                    title: this.$t('fbb.holiday.beginAt', { defaultValue: '节假日起始日期' }),
                    key: 'beginAt',
                    sortable:true,
                    render:(h, {
                        row
                    }) => {
                        return row.beginAt.substring(0,10)
                    }
                }, 
                {
                    title: this.$t('fbb.holiday.endAt', { defaultValue: '节假日结束日期' }),
                    key: 'endAt',
                    tag: 'vDatepicker',
                    sortable:true,
                    render:(h, {
                        row
                    }) => {
                        return row.endAt.substring(0,10)
                    }
                },{
                    title: this.$t('fbb.holiday.days', { defaultValue: '假日天数' }),
                    key: 'totalDays',
                },{
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },{
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                } ];
        },
    },
};




